import React from "react";
import { connect } from "react-redux";

const mapStateToProps = state => {
    return {
        profile: state.general.profile
    };
};

class Restrict extends React.Component {
    render() {
        const { profile, permissions } = this.props;
        let permissionFromUser = profile.permissions
            ? profile.permissions
            : ["global"];
        let AccessPermission = permissions ? permissions : ["global"];

        let allowed = false;
        permissionFromUser.forEach(permit => {
            let access = AccessPermission.includes(permit);
            if (access) allowed = access;
        });
        let resultAllowed = allowed ? this.props.children : null;
        return resultAllowed;
    }
}

export default connect(mapStateToProps, null)(Restrict);
